import React from 'react';

const DebtSummary = ({ importeDeuda, divisa, formatAmount }) => {
  return (
    <div className='p-6 border-b border-slate-200'>
      <h2 className='text-lg font-semibold text-slate-900 mb-4'>Tu deuda pendiente</h2>
      <div className='flex items-baseline justify-between mb-4'>
        <span className='text-slate-600'>Importe total</span>
        <span className='text-2xl font-bold text-slate-900'>{formatAmount(importeDeuda, divisa)}</span>
      </div>
      <p className='text-sm text-slate-500'>
        El importe exacto de tu deuda se muestra en la comunicación que has recibido.
      </p>
    </div>
  );
};

export default DebtSummary;
